import puspa1 from "./7.webp";
import puspa2 from "./9.webp";

const puspa = [puspa1, puspa2];

export default puspa;
